
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class VisitInstitute extends Vue {

  headerTranslations: Record<string, string> = {
    VisitIdentifier: "Kennung des Besuchs",
    InstituteName : "Name des Instituts",
    count: "Zählen"
  };

  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("visitInstitute");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("visitInstitute");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
